import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'
import { PERFORMANCE_SECTION_HEIGHT } from '../../utils'

export const Wrapper = styled(Box)<{ showUnread?: string }>`
  display: flex;
  height: ${PERFORMANCE_SECTION_HEIGHT}px;
  padding: ${theme.spacing.medium}px;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ showUnread }) => (showUnread === 'true' ? theme.spacing.xSmall : theme.spacing.medium)}px;
  border-radius: ${theme.attributes.borderRadius.quaternary};
  background: ${theme.colors.surfaceContainerBackground};
  width: 100%;

  .header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;

    .header-start {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.xSmall}px;

      .header-title {
        font-family: ${theme.typography.fontFamily.primary};
        color: ${theme.colors.menuItemText};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 24px;
        letter-spacing: 0.1px;
      }
    }

    .header-date {
      font-family: ${theme.typography.fontFamily.primary};
      color: ${theme.colors.cardDateText};
      text-align: right;
      font-size: ${theme.typography.fontSize.medium};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 16px;
      letter-spacing: 0.5px;
    }
  }

  .content {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: ${theme.spacing.small}px;
  }
`
